export default class Slideshow {
    constructor() {
        this.initSlideshow();
    }

    initSlideshow() {
        const slideshow = document.querySelector('.ilabs-slideshow');
        if (!slideshow) {
            return;
        }
        new Swiper(slideshow.querySelector('.swiper'), {
            slidesPerView: 1,
            effect: "fade",
            loop: true,
            autoplay: {
                delay: 5000,
            },
            navigation: {
                nextEl: slideshow.querySelector('.swiper-button-next'),
                prevEl: slideshow.querySelector('.swiper-button-prev'),
            },
        });
    }
}
  

